import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';
import ZIndex from 'styles/zIndex';
import { isMSTeams } from 'utils/MSTeams';

const GlobalStyle = createGlobalStyle`
  ${normalize()};
  @font-face {
    font-display: block;
    font-family: 'Inter';
    src: url('/fonts/Inter-Bold.ttf');
    src: local('Inter-Bold'),
        url('/fonts/Inter-Bold.ttf') format('truetype');
    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-display: block;
    font-family: 'Inter';
    src: url('/fonts/Inter-SemiBold.ttf');
    src: local('Inter-SemiBold'),
        url('/fonts/Inter-SemiBold.ttf') format('truetype');
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-display: block;
    font-family: 'Inter';
    src: url('/fonts/Inter-Medium.ttf');
    src: local('Inter-Medium'),
        url('/fonts/Inter-Medium.ttf') format('truetype');
    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-display: block;
    font-family: 'Inter';
    src: url('/fonts/Inter-Regular.ttf');
    src: local('Inter-Regular'),
        url('/fonts/Inter-Regular.ttf') format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-display: block;
    font-family: 'Inter';
    src: url('/fonts/Inter-Italic.ttf');
    src: local('Inter-Italic'),
        url('/fonts/Inter-Italic.ttf') format('truetype');
    font-style: italic;
    font-weight: 400;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body, #root {
    margin: 0;
    height: 100%;
    width: 100%;
    
    direction: ${({ theme }) => theme.direction || 'ltr'};

 ${({ theme }) =>
   theme.direction === 'rtl' &&
   `
    * {
      /* If something explicitly set text-align: left, override it */
      text-align: unset;
    }

    *[style*='text-align: left'],
    .align-left {
      text-align: right;
    }
  `}
  }

  html {
    overflow-y: overlay;
    overflow-x: ${isMSTeams() ? 'hidden' : 'visible'};
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  button {
    font-family: inherit;
  }

  /* Extend the z-index of the Design System tooltip component to be in the correct layer as defined in zIndex.ts */
  .tooltip-popover {
    z-index: ${ZIndex.tooltip};
  }

  /* A Design System dropdown with floatMenu portals its menu to the end of the
     body and reads its stacking order from this property, so it has to be
     declared globally rather than scoped to a dropdown. Above the modal layer,
     since the menu has to clear a modal it is opened inside. */
  :root {
    --ds-dropdown-menu-portal-z-index: ${ZIndex.overModal};
  }

  /* The Design System modal portals to the end of the body and ships a z-index
     below the authenticated page's bottom navigation, which sits at
     ZIndex.overModal so it clears Shared/Modal. Lift it the same way
     Shared/Modal does, or the navigation covers the modal on small screens.
     Global rather than scoped for the same reason as the dropdown above. */
  .modal__scrim {
    z-index: ${ZIndex.overMobileNav};
  }

  .modal {
    z-index: ${ZIndex.overMobileNav + 1};
  }
`;

export default GlobalStyle;
